import object from '@mailobj-browser/front/js/utils/object.js'

const block = 'ea_mail'

export const elements = object(null, {
  menu_button: `${block}__menu_button`,
  menu_item: `${block}__menu_item`,
  message: `${block}__message`,
  message_mailbox: `${block}__message_mailbox`,
  message_preview_side: `${block}__message_preview_side`,
  message_preview_under: `${block}__message_preview_under`,
  message_to: `${block}__message_to`,
  send: `${block}__send`,
  send_button_bar: `${block}__send_button_bar`,
  send_form: `${block}__send_form`,
  send_form_top: `${block}__send_form_top`,
  send_header_main: `${block}__send_header_main`,
  send_header_bcc: `${block}__send_header_bcc`,
  send_header_cc: `${block}__send_header_cc`,
  send_header_fields: `${block}__send_header_fields`,
  send_header_from: `${block}__send_header_from`,
  send_header_to: `${block}__send_header_to`,
  send_main: `${block}__send_main`,
  send_msg_html: `${block}__send_msg_html`,
  send_options: `${block}__send_options`,
  send_options_delays_planned: `${block}__send_options_delay_planned`,
  send_panel: `${block}__send_panel`,
  send_panel_transition: `${block}__send_panel_transition`,
  send_rte_actions: `${block}__send_rte_actions`,
  send_topbar: `${block}__send_topbar`,
  send_topbar_close: `${block}__send_topbar_close`,
})

export const modifiers = object(null, {
  menu_button: object(null, {
    hover: `${elements.menu_button}-hover`
  }),
  menu_item: object(null, {
    has_unseen: `${elements.menu_item}-has_unseen`
  }),
  send_collapse_collapsible: object(null, {
    open: `${elements.send_collapse_collapsible}-open`,
  }),
  send_main: object(null, {
    transform_start: `${elements.send_main}-transform_start`,
  }),
  send_panel: object(null, {
    open: `${elements.send_panel}-open`,
  }),
})
